import { bignumber, divide, multiply } from 'mathjs';
import { oneWithZeroes } from './helpers/number.helpers';

if (!Number.prototype.toFixedFloor) {
  Number.prototype.toFixedFloor = function(fractionDigits?: number) {
    if (!fractionDigits) {
      fractionDigits = 0;
    }
    const sign = Math.sign(this.valueOf());
    const amount = Math.abs(this.valueOf());
    const fraction = oneWithZeroes(fractionDigits);
    const a = bignumber(Math.floor(Number(multiply(bignumber(amount), bignumber(fraction)))));
    const floored = Number(divide(a, bignumber(fraction)));
    return (floored * sign).toFixed(fractionDigits);
  };
}

if (!Array.prototype.nearest) {
  Array.prototype.nearest = function(goal: number) {
    return (this.valueOf() || []).reduce(function(prev: number, curr: number) {
      return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
    });
  };
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/prototypes.ts